import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  return (
    <AuthContext.Provider value={{ showLoginPopup, setShowLoginPopup }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
